<template>
  <div class="manual-detail manual-page-layout">
    <embed
      :src="userManualData.pdfUrl"
      type="application/pdf"
      width="100%"
      :height="pdfHeight"
    />
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "userManualPage",
  props: {
    popupParam: {
      type: Object,
      default() {
        return {
          userManualId: "",
        };
      },
    },
  },
  data() {
    return {
      attachInfo: {
        isSubmit: "",
        taskClassCd: "USER_MANUAL",
        taskKey: "",
      },
      userManualData: {
        userManualId: "", // 사용자매뉴얼 일련번호
        taskName: "", // 업무명
        pdfUrl: "",
      },
      editable: true,
      detailUrl: "",
      pdfHeight: "600px",
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.setPdfHeight();
    window.addEventListener("resize", this.setPdfHeight);
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setPdfHeight);
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // code setting
      this.detailUrl = selectConfig.um.userManualPdf.get.url;
      // code setting
      // list setting
      this.getDetail();
    },
    getDetail() {
      this.$http.url = this.$format(
        this.detailUrl,
        this.popupParam.userManualId,
      );
      this.$http.type = "GET";
      this.$http.request((_result) => {
        this.userManualData = _result.data;
        // TODO: 고객사 파일저장소 위치에 따라 pdfUrl 설정
        console.log(
          "getDetail",
          process.env.VUE_APP_UPLOAD_TYPE,
          // import.meta.env.VITE_UPLOAD_TYPE
        );
        if (process.env.VUE_APP_UPLOAD_TYPE === "AWS") {
          this.userManualData.pdfUrl =
            "https://s3.andami.kr/shmsbucket/" + _result.data.pdfDownPath;
        } else {
          this.userManualData.pdfUrl =
            "https://ehs.dongoh.co.kr/files/" + _result.data.pdfDownPath;
          // nginx .conf 에서 alias 설정 ('/files/')
        }
        this.attachInfo.taskKey = _result.data.userManualId;
      });
    },
    setPdfHeight() {
      this.pdfHeight = window.innerHeight - 105 + "px";
    },
  },
};
</script>

<style scoped>
.manual-detail {
  padding: 10px;
}
.manual-page-layout img {
  width: 100%;
  height: auto;
}
</style>
